import { useTQC2090_R01Store } from './Store_TQC2090_R01';
import { TQC2090_R01_TABS } from './utils/tabConfig';

interface Props {
	/** 탭을 바꾸면 해당 라인으로 다시 조회한다. */
	onChangeLine: (workplaceCd: string) => void;
}

/**
 * 공정라인 탭. 마스터를 조회하지 않고 화면 고정값 두 개를 보여준다. (설계 문서 §4)
 *
 * 라인이 늘어나면 Dto_TQC2090_R01.TQC2090_R01_LINE_OPTIONS 와
 * 백엔드 TQC2090_R01Service 의 LINE_* 상수를 함께 고쳐야 한다.
 */
export const Tab_TQC2090_R01 = ({ onChangeLine }: Props) => {
	const { TQC2090_R01Filter } = useTQC2090_R01Store();

	return (
		<div
			className="flex items-end mb-[0.1px] bg-white h-[25px]"
			role="tablist"
			aria-label="공정라인 탭"
		>
				{TQC2090_R01_TABS.map((line) => {
				const isActive = TQC2090_R01Filter.workplaceCd === line.workplaceCd;
				return (
					<button
						key={line.workplaceCd}
						type="button"
						onClick={() => onChangeLine(line.workplaceCd)}
						role="tab"
						aria-selected={isActive}
						className={`h-[26px] px-3 text-[12px] font-medium transition-colors border border-gray-300 border-b-0
							${isActive
								? "bg-white text-black-700 -mb-px shadow-sm"
								: "bg-gray-100 text-gray-700 hover:bg-gray-200"}
						`}
					>
						{line.workplaceNm}
					</button>
				);
			})}
		</div>
	);
};
